const appConf = {
  name: '北京海源恒智科技有限公司',
  icp: '京ICP备19012382号-3',
  desc: `公司从2002年进入该行业，从配单起步,逐步发展壮大，现已成为专业的、合格的、值得您信赖的芯片供应商。我司本着服务至上，诚实守信的原则，为客户带来最优质的保障！`,
  descMainProduct: `主营：专门从事芯片贸易的原装器件供应商，主营AD、TI、MAX、ATMEL、ON 等品牌，多种渠道供货，保证原装正品！ 您的信赖 是我们最大的动力！`,
  bannerImg: [
    {
      url: 'static/img/1.jpg',
      title: '北京海源恒智科技有限公司',
      subtitle: '芯片配单，PCB板焊接',
    },
    {
      url: 'static/img/2.jpg',
      title: '支持BOM订单，采购更容易',
      subtitle: '电话：010-82126805',
    },
    {
      url: 'static/img/3.png',
      title: '芯片、电阻、电容、电感、电位器',
      subtitle: '接插件和航插、晶振、继电器、发光二极管',
    },
  ],
  footerDesc:
    '主营芯片、电阻、电容、电感、电位器、接插件和航插、晶振、继电器、发光二极管等电子元器件以及PCB板焊接',
  contact: {
    sz: {
      telephone: '0755-82567995',
      email: 'haiyuanhengzhi@163.com',
    },
    sale: {
      telephone: '010-82126805',
      phone: '18600149727',
      contact: '韩经理',
      email: 'yuhaimei79@163.com',
      qq: '401026271',
      wechat: '18600149727',
      tax: '010-82126805',
    },
    address: [
      {
        name: '总部',
        address: '北京市海淀区知春里甲10号誉德商务楼503、504室',
      },
      {
        name: '深圳办事处',
        address: '深圳市华强北华强C座27i',
      },
      {
        name: '香港办事处',
        address: '香港九龙观塘骏业街60号骏运工业大厦14楼A室',
      },
      {
        name: '焊接工厂',
        address: '河北省保定市高碑店市方官镇和谷小镇A14号楼',
      },
    ],
  },
  product: [
    {
      imgurl: 'static/img/1.jpg',
      name: '芯片',
      desc:
        '芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片',
    },
    {
      imgurl: 'static/img/2.jpg',
      name: '芯片',
      desc:
        '芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片',
    },
    {
      imgurl: 'static/img/3.png',
      name: '芯片',
      desc:
        '芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片',
    },
    {
      imgurl: 'static/img/2.jpg',
      name: '芯片',
      desc:
        '芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片芯片',
    },
  ],
}
export default appConf;
